<template>
  <v-card
    flat
    color="white"
    class="mb-7"
  >
    <v-tabs
      v-if="getTabs.main === 'additionalInfo'"
      :key="`additionalInfo-${tabsKey}`"
      :value="getTabs.sub"
      @change="onSubTabChange"
      grow
      color="third"
    >
      <v-tab
        v-for="subTab in addInfoSubTabs"
        :key="subTab.id"
        :href="`#${subTab.id}`"
        :disabled="getGlobalLoadStatus"
        @click.prevent="onTabClick($event, subTab.id)"
      >
        {{ subTab.name }}
      </v-tab>
    </v-tabs>

    <v-tabs
      v-else-if="getTabs.main === 'products'"
      :key="`products-${tabsKey}`"
      :value="getTabs.sub"
      @change="onSubTabChange"
      grow
      color="third"
    >
      <v-tab
        v-for="subTab in productSubTabs()"
        :key="subTab.id"
        :href="`#${subTab.id}`"
        :disabled="getGlobalLoadStatus"
        @click.prevent="onTabClick($event, subTab.id)"
      >
        {{ subTab.name }}
      </v-tab>
    </v-tabs>

    <v-dialog
      v-model="notAllowedDialog"
      max-width="520"
      persistent
    >
      <v-card>
        <v-card-title class="text-h6">
          You must complete previous forms to continue
        </v-card-title>

        <v-card-text>
          {{ notAllowedReason }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="third"
            text
            @click="closeNotAllowedDialog"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SubTab',
  data() {
    return {
      tabsKey: 0,
      notAllowedDialog: false,
      notAllowedReason: '',
    };
  },
  computed: {
    ...mapGetters([
      'getGlobalLoadStatus',
      'getTabs',
      'productSubTabs',
      'addInfoSubTabs',
      'canGoToTab',
    ]),
  },
  methods: {
    ...mapActions(['setSubTab']),

    isTabAllowed(tabId) {
      const permission = this.canGoToTab(tabId);
      return { ok: Boolean(permission?.status), reason: permission?.reason };
    },

    showNotAllowedReason(reason) {
      console.log("no available!");
      this.notAllowedReason = reason || 'This tab is not available right now.';
      this.notAllowedDialog = true;
    },

    closeNotAllowedDialog() {
      this.notAllowedDialog = false;
      this.notAllowedReason = '';
    },

    onTabClick(event, tabId) {
      const { ok, reason } = this.isTabAllowed(tabId);
      if (ok) return;

      event.preventDefault();
      event.stopPropagation();
      this.tabsKey += 1;
      this.showNotAllowedReason(reason);

      // Force tabs to re-render so any incorrectly applied v-tab--active is cleared
    },

    onSubTabChange(nextTab) {
      const nextTabId = typeof nextTab === 'string'
        ? nextTab.replace(/^#/, '')
        : nextTab;

      const { ok, reason } = this.isTabAllowed(nextTabId);

      if (ok) {
        this.setSubTab(nextTabId);
        return;
      }
      this.tabsKey += 1;
      this.showNotAllowedReason(reason);
    },
  },
};
</script>
